import convertDate from 'shared/utils/convertDate';
import Address from './Address';
import Employer from './Employer';
import Reference from './Reference';

class Applicant {
	constructor(
		currentEmployment = {},
		currentResidence = {},
		numberofReferencesforCoApplicant = 0,
		numberofReferencesOnCreditApplication = 0,
		personalInformation = {},
		previousEmployment = {},
		previousResidence = {},
		references = [],
	) {
		this.cellPhone = currentResidence.cellPhone || '';
		this.currentAddress = new Address(personalInformation);
		this.currentAddressTermStart = convertDate(currentResidence.currentAddressTermStart) || '';
		this.currentEmployer = new Employer(currentEmployment);
		this.dob = convertDate(personalInformation.dob) || '';
		this.driversLicense = personalInformation.driversLicense || '';
		this.driversLicenseState = personalInformation.driversLicenseState || '';
		this.driversLicenseExpDate = convertDate(personalInformation.driversLicenseExpDate) || '';
		this.emailAddress = personalInformation.emailAddress || '';
		// TO DO : determine difference between employmentStatus and employmentStatusGuid
		this.employmentStatus = currentEmployment.employmentStatus || '';
		this.employmentStatusGuid = currentEmployment.employmentStatus || '';
		this.firstName = personalInformation.firstName || '';
		this.fullName = personalInformation.fullName || '';
		this.gender = personalInformation.gender || '';
		this.hasCheckingAccount = personalInformation.hasCheckingAccount || false;
		this.hasSavingsAccount = personalInformation.hasSavingsAccount || false;
		this.homePhone = currentResidence.homePhone || '';
		this.homeValue = currentResidence.homeValue || '';
		this.housingIndicator = currentResidence.housingIndicator || '';
		this.income = currentEmployment.income || 0;
		this.incomeIndicator = currentEmployment.incomeIndicator || '';
		this.lastName = personalInformation.lastName || '';
		this.maritalStatus = personalInformation.maritalStatus || '';
		this.middleInitial = personalInformation.middleInitial || '';
		this.monthlyRent = currentResidence.monthlyRent || '';
		this.mortgageBalance = currentResidence.mortgageBalance || 0;
		this.mortgageCompany = currentResidence.mortgageCompany || '';
		this.mothersMaidenName = personalInformation.mothersMaidenName || '';
		this.netIncome = currentEmployment.netIncome || 0;
		this.numberOfDependents = personalInformation.numberOfDependents || '';
		this.numberofReferencesforCoApplicant = numberofReferencesforCoApplicant || 0;
		this.numberofReferencesOnCreditApplication = numberofReferencesOnCreditApplication || 0;
		this.otherIncome = personalInformation.otherIncome || '';
		this.otherIncomeType = personalInformation.otherIncomeType || '';
		this.previousAddress = new Address(previousResidence);
		this.previousAddressTermEnd = convertDate(previousResidence.previousAddressTermEnd) || '';
		this.previousAddressTermStart = convertDate(previousResidence.previousAddressTermStart) || '';
		this.previousEmployer = new Employer(previousEmployment);
		this.references = references.map(ref => new Reference(ref));
		this.requestedAmount = personalInformation.requestedAmount || '';
		this.selfEmployed = currentEmployment.selfEmployed || false;
		this.ssn = personalInformation.ssn || '';
	}
}

export default Applicant;
